import styled from 'styled-components'

export const Container = styled.div`
  padding: 0;
  width: 100%;
`

export const Grid = styled.div<{ $columns?: number }>`
  display: grid;
  grid-template-columns: repeat(${({ $columns }) => $columns || 3}, 1fr);
  gap: 20px;
  margin-bottom: 24px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const Card = styled.div`
  background: ${({ theme }) => theme.colors.background.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-radius: 8px;
  padding: 24px;
`

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`

export const CardTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text};
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
`

export const MetricGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const MetricRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 12px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
`

export const MetricLabel = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text.secondary};
  display: flex;
  align-items: center;
  gap: 6px;
`

export const MetricValue = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text};
  text-align: right;
`

export const MetricHighlight = styled.div<{
  $type?: 'success' | 'warning' | 'danger' | 'info' | 'default'
  $textAlign?: 'left' | 'center' | 'right'
}>`
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  text-align: ${({ $textAlign }) => $textAlign || 'left'};
  background: ${({ $type, theme }) => {
    switch ($type) {
      case 'success':
        return '#10b98115'
      case 'warning':
        return '#f59e0b15'
      case 'danger':
        return '#ef444415'
      case 'info':
        return '#3b82f615'
      default:
        return typeof theme.colors.surface === 'string'
          ? theme.colors.surface
          : '#f8f9fa'
    }
  }};
  color: ${({ $type }) => {
    switch ($type) {
      case 'success':
        return '#10b981'
      case 'warning':
        return '#f59e0b'
      case 'danger':
        return '#ef4444'
      case 'info':
        return '#3b82f6'
      default:
        return 'inherit'
    }
  }};
`

export const ChartContainer = styled.div`
  width: 100%;
  height: 400px;
  margin-top: 16px;
`

export const SectionDivider = styled.div`
  height: 1px;
  background: ${({ theme }) => theme.colors.border.light};
  margin: 32px 0;
`

export const SectionTitle = styled.h4`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text};
  margin: 0 0 16px 0;
  display: flex;
  align-items: center;
  gap: 8px;
`

export const InfoBanner = styled.div<{
  $type?: 'info' | 'warning' | 'success' | 'danger'
}>`
  padding: 16px 20px;
  border-radius: 8px;
  margin-bottom: 24px;
  background: ${({ $type }) => {
    switch ($type) {
      case 'warning':
        return '#f59e0b10'
      case 'success':
        return '#10b98110'
      case 'danger':
        return '#ef444410'
      default:
        return '#3b82f610'
    }
  }};
  border-left: 4px solid
    ${({ $type }) => {
      switch ($type) {
        case 'warning':
          return '#f59e0b'
        case 'success':
          return '#10b981'
        case 'danger':
          return '#ef4444'
        default:
          return '#3b82f6'
      }
    }};
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text.secondary};
  line-height: 1.5;

  strong {
    color: ${({ theme }) => theme.colors.text};
    font-weight: 600;
  }
`
